import React, { useState, useRef } from 'react';
import i18next from 'i18next';

import { TertiaryButton } from '~/components/Button';
import SearchInput from '~/components/TextInput/Search';
// import Spinner from '~/components/Spinner';

import { useParams } from 'react-router-dom';
import Table from './components/Table';

import {
  Container,
  Header,
  TitleWrapper,
  Title,
  IconPlus,
  ActionsWrapper,
  SearchAndNewButton,
  WrapperDep,
} from './styles';
import CreateOptionModal from './components/CreateOptionModal';

const SelectOptions = () => {
  const [searchValue, setSearchValue] = useState('');
  const searchInputRef = useRef(null);
  const [optionModal, setOptionModal] = useState(false);
  const [editOption, setEditOption] = useState({});

  const handleCloseDepartamentModal = () => {
    setOptionModal(false);
    setEditOption({});
  };

  const { iventoryOption } = useParams();

  const titleFormated = () => {
    switch (iventoryOption) {
      case 'collection_purpose':
        return i18next.t('iventory.collectionPurpose');
      case 'collection_forms':
        return i18next.t('iventory.collectionForms');
      case 'category_of_data_collected':
        return i18next.t('iventory.categoryOfDataCollected');
      case 'transparency_to_the_holder':
        return i18next.t('iventory.transparencyToTheHolder');
      case 'collected_data':
        return i18next.t('iventory.collectedData');
      case 'legal_basis_assessment':
        return i18next.t('iventory.legalBasisAssessment');
      case 'process_update_frequency':
        return i18next.t('iventory.processUpdateFrequency');
      case 'in_out_transmission':
        return i18next.t('iventory.InOutTransmission');
      case 'storage_forms':
        return i18next.t('iventory.storageForms');
      default:
        return '-';
    }
  };

  return (
    <Container>
      <Header>
        <TitleWrapper>
          <Title>{titleFormated()}</Title>
        </TitleWrapper>
        <ActionsWrapper>
          <SearchAndNewButton>
            <WrapperDep>
              <SearchInput
                inputRef={searchInputRef}
                placeholder={i18next.t('common.search')}
                value={searchValue}
                onChange={setSearchValue}
                delay={1500}
                hasDebounce
              />
              <TertiaryButton
                onClick={() => setOptionModal(true)}
                label={i18next.t('common.buttons.new')}
                leftIcon={<IconPlus />}
              />
            </WrapperDep>
          </SearchAndNewButton>
        </ActionsWrapper>
      </Header>
      <Table
        search={searchValue}
        setEditDepartament={setEditOption}
        setDepartamentModal={setOptionModal}
      />
      <CreateOptionModal
        open={!!optionModal}
        editOption={editOption}
        onClose={handleCloseDepartamentModal}
      />
    </Container>
  );
};

export default SelectOptions;
